'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitPayment = exports.getUiSubmitPayment = exports.SUBMIT_PAYMENT_SUCCESS = exports.SUBMIT_PAYMENT_REQUEST = exports.SUBMIT_PAYMENT_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('./user');

var _api = require('../api');

var _reselect = require('reselect');

var _modal = require('./modal');

var _config = require('./config');

var _getStripeErrorMessageFromResponse = require('../../utils/getStripeErrorMessageFromResponse');

var _getStripeErrorMessageFromResponse2 = _interopRequireDefault(_getStripeErrorMessageFromResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SUBMIT_PAYMENT_FAIL = exports.SUBMIT_PAYMENT_FAIL = 'la/ui/payment/FAIL';
var SUBMIT_PAYMENT_REQUEST = exports.SUBMIT_PAYMENT_REQUEST = 'la/ui/payment/REQUEST';
var SUBMIT_PAYMENT_SUCCESS = exports.SUBMIT_PAYMENT_SUCCESS = 'la/ui/payment/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SUBMIT_PAYMENT_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case SUBMIT_PAYMENT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case SUBMIT_PAYMENT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: (0, _getStripeErrorMessageFromResponse2.default)(action.payload),
                submitted: false,
                success: false
            });
        case _modal.DISMISS_MODAL:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.payment;
};

var getUiSubmitPayment = exports.getUiSubmitPayment = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitPayment = exports.submitPayment = function submitPayment(_ref) {
    var address = _ref.address,
        amount = _ref.amount,
        cardToken = _ref.cardToken,
        catalogId = _ref.catalogId,
        currency = _ref.currency;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, bidderId, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            bidderId = (0, _user.getBidderId)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: bidderId,
                                type: SUBMIT_PAYMENT_REQUEST
                            });
                            _context.next = 8;
                            return _api.Auth.postPayment({
                                address: address,
                                amount: amount,
                                authToken: authToken,
                                bidderId: bidderId,
                                cardToken: cardToken,
                                catalogId: catalogId,
                                currency: currency,
                                deployment: deployment
                            });

                        case 8:
                            response = _context.sent;


                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: SUBMIT_PAYMENT_SUCCESS
                            });
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: SUBMIT_PAYMENT_FAIL
                            });
                            throw _context.t0;

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/payment.js
// module id = 2JX2
// module chunks = 60